export const reportMfRemoteFailure = async (remoteName: string, error: unknown): Promise<void> => {
  const { SentryService } = await import(/* webpackChunkName: "Services" */ "@callcenter/services")

  SentryService.notify(
    `Module Federation: remote "${remoteName}" unavailable, fell back to local`,
    { error: error instanceof Error ? { name: error.name, message: error.message } : String(error) },
    `mf-remote-unavailable:${remoteName}`
  )
}
